module.exports = __webpack_public_path__ + "static/media/cocobo.e3bde689.png";